import { Desc } from '@sm/intl';

import COPY from '~pricing/copy';

export enum Sources {
  PRICINGWEB = 'pricingweb',
}

export enum Packages {
  Basic = 'BASIC',

  StandardMonthly = 'STANDARD_MONTHLY',
  StandardAnnual = 'STANDARD_ANNUAL', // This is preserve because of canonical name (which it may never change)

  StarterMonthly = 'STARTER_MONTHLY',
  StarterAnnual = 'STANDARD_ANNUAL',

  AdvantageMonthly = 'ADVANTAGE_MONTHLY',
  AdvantageAnnual = 'ADVANTAGE_ANNUAL',

  PremierMonthly = 'PREMIER_MONTHLY',
  PremierAnnual = 'PREMIER_ANNUAL',

  TeamAdvantage = 'TEAM_ADVANTAGE_ANNUAL',
  TeamPremier = 'TEAM_PREMIER_ANNUAL',

  Enterprise = 'ENT_PLATINUM',
  Flex = 'ANALYZE_MONTHLY',

  FormsMonthly = 'FORMS_MONTHLY',
  FormsAnnual = 'FORMS_ANNUAL',
}

export const PackageIds: Record<Packages, number> = {
  [Packages.Basic]: 1,
  [Packages.StandardMonthly]: 31,
  [Packages.StandardAnnual]: 32, // See Packages

  [Packages.StarterMonthly]: 31,
  [Packages.StarterAnnual]: 32,

  [Packages.AdvantageMonthly]: 33,
  [Packages.AdvantageAnnual]: 34,

  [Packages.PremierMonthly]: 35,
  [Packages.PremierAnnual]: 36,

  [Packages.TeamAdvantage]: 134,
  [Packages.TeamPremier]: 136,

  [Packages.Enterprise]: 26,
  [Packages.Flex]: 37,

  [Packages.FormsMonthly]: 41,
  [Packages.FormsAnnual]: 42,
};

export const ComparePlanIds: string[] = [
  Packages.Basic,
  Packages.StandardMonthly,
  Packages.StarterAnnual,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
  Packages.Enterprise,
];

export enum LanguageCodes {
  PT = 'pt',
  EN = 'en-US',
  GB = 'en-GB',
  FR = 'fr',
  ES = 'es',
}

export enum SkuTypes {
  CoreSeat = 'SUBSCRIPTION_CORE_SEAT',
  AdditionalSeat = 'SUBSCRIPTION_ADDITIONAL_SEAT',
  ResponseOverage = 'RESPONSES',
}

/**
 * Localization should only happen in the L10nProvider
 * See https://github.com/pages/mntv-webplatform/smweb/#/pages/webs/localization?id=ltl10nprovidergt-t-and-lttgt
 */
export const PackageDisplayNames: Record<Packages, Desc> = {
  [Packages.Basic]: COPY.BASIC,
  [Packages.StandardMonthly]: COPY.STANDARD_MONTHLY,
  [Packages.StandardAnnual]: COPY.STANDARD_ANNUAL, // In the process of decommissioning but who knows, maybe never
  [Packages.StarterMonthly]: COPY.STARTER_MONTHLY,
  [Packages.StarterAnnual]: COPY.STARTER_ANNUAL,
  [Packages.AdvantageMonthly]: COPY.ADVANTAGE_MONTHLY,
  [Packages.AdvantageAnnual]: COPY.ADVANTAGE_ANNUAL,
  [Packages.PremierMonthly]: COPY.PREMIER_MONTHLY,
  [Packages.PremierAnnual]: COPY.PREMIER_ANNUAL,
  [Packages.TeamAdvantage]: COPY.TEAM_ADVANTAGE,
  [Packages.TeamPremier]: COPY.TEAM_PREMIER,
  [Packages.Enterprise]: COPY.ENT_PLATINUM,
  [Packages.Flex]: COPY.STANDARD_MONTHLY,
  [Packages.FormsMonthly]: COPY.FORMS,
  [Packages.FormsAnnual]: COPY.FORMS,
};
